import { style } from 'typestyle'
export const pb12 = style({ paddingBottom: '12px' })
